import { Link } from 'react-router-dom'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'
import type { Quote } from '../types'

interface QuoteCardProps {
  quote: Quote
}

export const QuoteCard = ({ quote }: QuoteCardProps) => {
  const formattedDate = quote.created_at
    ? format(new Date(quote.created_at), 'dd. MMM yyyy', { locale: de })
    : ''

  const text = quote.text_content ?? ''
  const sourceLabel = quote.source?.authors?.length
    ? quote.source.authors.map((a) => a.name).join(', ')
    : quote.source?.title ?? ''

  return (
    <Link to={`/quote/${quote.id}`} className="quote-card">
      {text ? (
        <blockquote className="quote-text">
          &ldquo;{text.substring(0, 200)}&rdquo;
          {text.length > 200 && '…'}
        </blockquote>
      ) : (
        <div className="quote-text" style={{ color: '#718096', fontStyle: 'normal' }}>
          📷 {quote.images.length} Bild{quote.images.length !== 1 ? 'er' : ''}
        </div>
      )}

      <div className="quote-meta">
        <span className="quote-author">{sourceLabel}</span>
        <span>{formattedDate}</span>
      </div>

      {quote.tags.length > 0 && (
        <div className="quote-tags">
          {quote.tags.slice(0, 5).map((tag) => (
            <span key={tag.id} className="tag">
              {tag.name}
            </span>
          ))}
          {quote.tags.length > 5 && (
            <span className="tag">+{quote.tags.length - 5}</span>
          )}
        </div>
      )}
    </Link>
  )
}
